<div class="container">
  <h1 mat-dialog-title class="report-form-header">Reasons:</h1>
  @for (reason of reasons; track reason) {
    <ul class="reasons"><li>{{ reason }}</li></ul>
  }
  <div class="btn-group" role="group">
    <button mat-raised-button color="primary" mat-dialog-close class="cursor-pointer">Close</button>
  </div>
</div>